import { axios } from '@/utils/request'

const api = {
  expressTplList: '/badminapi/express/tplList',
  expressTplOptions: '/badminapi/express/tplOptions',
  expressTplAdd: '/badminapi/express/tplAdd',
  expressTplEdit: '/badminapi/express/tplEdit',
  expressTplDelete: '/badminapi/express/tplDelete',
  expressTplDetail: '/badminapi/express/tplDetail',
  expressCompanyList: '/badminapi/express/expressCompanyList',
}
export default api

export function addExpressTpl(parameter) {
  return axios({
    url: api.expressTplAdd,
    method: 'post',
    data: parameter
  })
}
export function editExpressTpl(parameter) {
  return axios({
    url: api.expressTplEdit,
    method: 'post',
    data: parameter
  })
}
export function getExpressTplList(parameter) {
  return axios({
    url: api.expressTplList,
    method: 'get',
    params: parameter
  })
}
export function getExpressTplOptions(parameter) {
  return axios({
    url: api.expressTplOptions,
    method: 'get',
    params: parameter
  })
}
export function deleteExpressTpl(parameter) {
  return axios({
    url: api.expressTplDelete,
    method: 'post',
    data: parameter
  })
}
export function getExpressTplDetail(parameter) {
  return axios({
    url: api.expressTplDetail,
    method: 'get',
    params: parameter
  })
}
export function expressCompanyList(parameter) {
  return axios({
    url: api.expressCompanyList,
    method: 'get',
    params: parameter
  })
}